<div [ngClass]="{ 'container-fluid': !modalMode }">
  <div class="row">
    <div class="col-12">
      <div [ngClass]="{ 'container-shadow': !modalMode, 'ml-auto': !modalMode, 'mr-auto': !modalMode, 'mb-5': !modalMode, 'mb-3': modalMode }" style="padding: 40px 20px 40px 20px">
        <div *ngIf="loading" class="p-5 text-center">
          <i class="fas fa-spinner fa-5x fa-fw fa-pulse"></i>
        </div>
        <div *ngIf="!loading && event">
          <h5 class="text-center pb-4">
            <span *ngIf="techDebug">{{ event.id }}&nbsp;</span>{{ event.event_type_name }}
          </h5>
          <table class="table table-sm">
            <tbody>
              <tr>
                <th scope="row" class="text-right">Date/Time:</th>
                <td [innerHTML]="event.event_title_date | safeHtml"></td>
              </tr>
              <tr>
                <th scope="row" class="text-right">Duration:</th>
                <td [innerHTML]="event.humanized_duration | safeHtml"></td>
              </tr>
              <tr>
                <th scope="row" class="text-right">Reminder</th>
                <td>
                  <span *ngIf="event.formatted_reminder" [innerHTML]="event.formatted_reminder | safeHtml"></span>
                  <span *ngIf="event.formatted_reminder && event.reminder_id">&nbsp;</span>
                  <span *ngIf="event.reminder_id">
                    <a href="#" (click)="$event.preventDefault(); openReminder(event.reminder_id)">View</a>
                  </span>
                  <span *ngIf="!event.formatted_reminder">Not set</span>
                </td>
              </tr>
              <tr>
                <th scope="row" class="text-right">Repeat:</th>
                <td>
                  <span *ngIf="event.formatted_rrule" [innerHTML]="event.formatted_rrule | safeHtml"></span>
                  <span *ngIf="!event.formatted_rrule">Does not repeat</span>
                </td>
              </tr>
              <tr>
                <th scope="row" class="text-right">Matter:</th>
                <td>
                  <span *ngIf="event.matter_id">
                    <a [routerLink]="'/matters/' + event.matter_id">{{ event.matter_number }}</a> - {{ event.matter_name }}
                  </span>
                </td>
              </tr>
              <tr *ngIf="event.address_id">
                <th scope="row" class="text-right">Address:</th>
                <td>
                  <span *ngIf="event.address_id">
                    @&nbsp;
                    <strong>{{ event.address_name }}</strong>
                    <br />
                    <a *ngIf="event.address_id" href="javascript: void(0)" (click)="openAddress()">
                      <span [innerHTML]="event.full_address | safeHtml"></span>
                      <i class="fas fa-road"></i>
                    </a>
                  </span>
                </td>
              </tr>
              <tr *ngIf="event.phone_number_id && event.phone_event">
                <th scope="row" class="text-right">Phone:</th>
                <td>
                  <a appPhoneCallBilling phoneCallContactName="" [href]="'tel:' + event.phone" title="Call {{ event.phone }}"><i class="fas fa-phone fa-xs"></i>&nbsp;{{ event.phone }}</a>
                </td>
              </tr>
              <tr>
                <th scope="row" class="text-right">Created At:</th>
                <td>
                  <span *ngIf="event.created_at"> {{ event.created_at }}&nbsp;by&nbsp; </span>
                  <span *ngIf="event.created_by_link">
                    <a [ngStyle]="{ color: event.created_by_color_code }" [routerLink]="event.created_by_link">{{ event.created_by_person_name }}</a>
                  </span>
                </td>
              </tr>
              <tr>
                <th scope="row" class="text-right">Updated At:</th>
                <td>
                  <span *ngIf="event.updated_at"> {{ event.updated_at }}&nbsp;by&nbsp; </span>
                  <span *ngIf="event.updated_by_link">
                    <a [ngStyle]="{ color: event.updated_by_color_code }" [routerLink]="event.updated_by_link">{{ event.updated_by_person_name }}</a>
                  </span>
                </td>
              </tr>
              <tr>
                <th scope="row" class="text-right">Active:</th>
                <td>
                  <span *ngIf="event.is_active" class="text-success">Yes</span>
                  <span *ngIf="!event.is_active" class="text-danger">No</span>
                </td>
              </tr>
            </tbody>
          </table>
          <div *ngIf="event.private">
            <h6 class="text-muted">This is a private event</h6>
          </div>
          <div *ngIf="event.matter_user_attendees.length > 0">
            <br />
            <h6>User Attendees</h6>
            <div *ngFor="let attendee of event.matter_user_attendees">
              <a [ngStyle]="{ color: attendee.color }" [routerLink]="attendee.link">{{ attendee.name }}</a>
            </div>
          </div>
          <div class="py-1"></div>
          <div *ngIf="event.involvement_attendees.length > 0">
            <h6>Involvement Attendees</h6>
            <div *ngFor="let attendee of event.involvement_attendees">
              <a [routerLink]="attendee.link">{{ attendee.name }}</a>
            </div>
          </div>
          <br />
          <h6>Description</h6>
          <div [innerHTML]="event.notes || '' | safeHtml"></div>
          <div class="pt-4 pb-3 text-center" *ngIf="allowEdit">
            <button [ngClass]="{ 'btn-block': modalMode }" (click)="edit()" type="button" class="btn btn-primary">Edit</button>
            <span *ngIf="!modalMode">&nbsp;</span>
            <button *ngIf="!modalMode" (click)="back()" type="button" class="btn btn-light">Back</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
